module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/bg-container-orange-8c2c2ac94f17036553c596a07aed08cb.png";